


































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UploadFile } from "@/request/common";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Watch("data", { immediate: true })
  private dataChange() {
    this.detail = JSON.parse(JSON.stringify(this.data));
  }
  @Prop()
  private type: any;
  @Prop()
  private IfShow: any;
  @Watch("IfShow", { immediate: true })
  private IfShowChange() {
    this.ifVisible = this.IfShow;
  }
  private ifVisible: any = false;
  private detail: any = {
    file_list: [],
  };
  private beforeAvatarUpload(file: any) {
    const isLt100M = file.size / 1024 / 1024 < 100;

    if (!isLt100M) {
      this.$message.error("上传文件大小不能超过100MB!");
    }
    return isLt100M;
  }
  private preview(url: any) {
    window.open(url);
  }
  private cancel() {
    this.$emit("cancel");
  }
  private sure() {
    if (!this.detail["名称"]) {
      this.$message.warning("请输入名称!");
      return;
    }
    if (this.detail.file_list.length == 0) {
      this.$message.warning("请上传" + this.type + "!");
      return;
    }
    this.$emit("change", this.detail);
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading)
      .then((res: any) => {
        loading.close();
        this.detail.file_list = [res.full_file_url];
      })
      .catch(() => {
        loading.close();
      });
  }
}
